// import React, { useState } from 'react';
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// function AccountDetailsModal({modal, toggle}) {
//   return (
//     <div>
//       <Modal isOpen={modal} toggle={toggle}>
//         <ModalHeader toggle={toggle}>Bank Details</ModalHeader>
//         <ModalBody>
//           <div>
//             Holder Name:
//           </div>
//           <div>
//             Account Number:
//           </div>
//           <div>
//             IFSC Code:
//           </div>
//         </ModalBody>
//         <ModalFooter>
//           <Button color="primary" onClick={toggle}>
//             Do Something
//           </Button>{' '}
//           <Button color="secondary" onClick={toggle}>
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </div>
//   );
// }

// export default AccountDetailsModal;

import React, { useState } from "react";
import { Formik, Field, ErrorMessage } from "formik";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  FormGroup,
  NavLink,
  ModalFooter,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import SvgImage from "../../Icons/Icons";
import { useDispatch,useSelector } from "react-redux";
import { createPaymentLink } from "../../../services/Store/Actions/receivableActions";
import AskForPaymentModal from "../askForPayment";
import * as Yup from "yup";
import { sendAnalitics } from "../../../services/Store/Actions/appActions";
import { generateFreshdeskTicketV2 } from "../../../services/Store/Actions/driverslistActions";
import { toast } from "react-toastify";

function AccountDetailsModal(props) {
  const {
    modal,
    toggle,
    title,
    handleClick,
    pendingMoney,
    handleClose,
    btn,
    customer,
  } = props;
  const { salaryWalletDetails } = useSelector(
    state => state?.driverlist,
  );

  const customId1 = "custom-id-download page";
  const notify1 = () => toast.success("Your request is submitted successfully.", {
    toastId: customId1
  });

  const [active, setActive] = useState(false);
  //const [copyText, setCopyText] = useState("");
  const [copyIcon, setCopyIcon] = useState(0);
  const [link, setLink] = useState("");
  function handleActive() {
    handleClose();
    setActive(true);
  }
  function handleActiveClose() {
    setCopyIcon(0);
    setActive(false);
  }
  function toggleActiveModal() {
    setCopyIcon(0);
    setActive(!active);
  }
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    amount: Yup.number().typeError("Only Numbers are allowed")
      .required("Required")
      .min(1, "Amount should be greater than 1")
      .max(pendingMoney, "Amount should be less than pending amount")
  });

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className="positons settingModalMargin"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <div className="modal-content" style={{width:"530px", overflowY:"scroll", overflowX:"hidden"}} >
        <div className="modal-head-part">
          <p className="Add-balance-title">Bank Details</p>
          <Button
            type="button"
            className="close-btn"
            onClick={()=>{
              dispatch(sendAnalitics("Close_Payment_MC_web"));
              toggle();
            } }
            aria-label="Close"
          >
            <SvgImage name="CloseButtonLogo" />
          </Button>
        </div>
        <ModalBody>
                  <div className="sub-title-1">
                    <span class="circle-logo">1</span>
                    <label
                      htmlFor="amount"
                      className="sub-title-edit-vehicle-detial "
                    >
                      Holder Name
                    </label>
                  </div>
                  <div className="enter-pending-money">
                    <p>{salaryWalletDetails?.fullName==null?"N/A":salaryWalletDetails?.fullName}</p>
                  </div>

                  <div className="sub-title-1">
                    <span class="circle-logo">2</span>
                    <label
                      htmlFor="amount"
                      className="sub-title-edit-vehicle-detial "
                    >
                      Account Number
                    </label>
                  </div>
                  <div className="enter-pending-money">
                    <p>{salaryWalletDetails?.accountNo==null?"N/A":salaryWalletDetails?.accountNo}</p>
                  </div>

                  <div className="sub-title-1">
                    <span class="circle-logo">3</span>
                    <label
                      htmlFor="amount"
                      className="sub-title-edit-vehicle-detial "
                    >
                      IFSC Code
                    </label>
                  </div>
                  <div className="enter-pending-money">
                    <p>{salaryWalletDetails?.ifsc==null?"N/A":salaryWalletDetails?.ifsc}</p>
                  </div>
        </ModalBody>
        <ModalFooter>
          <div 
            className="enter-pending-money" 
            style={{cursor:'pointer', textDecorationLine:'underline', color:'#ED752E'}}
            onClick={() => {
              const body = {
                queryType: 'Salary Bank Details update Query',
                issue: 'Salary Bank Details update Query',
                desc: 'Salary Bank Details update Query',
              };
            dispatch(
                generateFreshdeskTicketV2(body, res => {
                    if (res?.data?.type === 'success') {
                        console.log((res?.data?.message) || 'error');
                        const blob = new Blob([res?.data])
                        const link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        // link.download = `file.xls`; //name to changed here
                        // link.click();
                          notify1();
                    }
                }),
            );
        }}
          >
            Change Bank Details?
          </div>
        </ModalFooter>
        </div>
      </Modal>
    </div>
  );
}

export default AccountDetailsModal;
